import { settings } from '../config';
import { Comments } from '../types/messages';
import { 
    CertificateAircraftCategory, 
    CertificateRating, 
    CertificateData, 
    Certificates, 
    RatingsDifference, 
    License, 
    MxiLicenseCode, 
    Skill 
} from '../types/certificates';
import { getToken } from './../global/TokenValidator';

class CertificateApi {
    GetAllCertififcateAircraftCategories = async (): Promise<{ status: Boolean, data: CertificateAircraftCategory[] }> => {
        return fetch(`${settings.HOST}/Certificate/GetAllCertififcateAircraftCategories`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),

            },
        }).then(x => {
            return x.json()
        })
    }
    GetCertificateForMe = async (): Promise<{ status: boolean, message: string, data: CertificateData }> => {
        return fetch(`${settings.HOST}/Certificate/GetCertificateForMe`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            }
        }).then(x => {
            return x.json()
        })
    }

    GetCertificateByEmployeeId = async (id: number): Promise<{ status: boolean, message: string, data: CertificateData }> => {
        return fetch(`${settings.HOST}/Certificate/GetCertificateByEmployeeId/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            }
        }).then(x => {
            return x.json()
        })
    }

    GetMessagesCertificateId = async (certificateId: number): Promise<{ status: boolean, data: Array<Comments> }> => {
        return fetch(`${settings.HOST}/Certificate/GetMessagesCertificateId/${certificateId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            }
        }).then(x => {
            return x.json()
        })
    }
    GetAllCertificationRatings = async (): Promise<{ status: Boolean, data: CertificateRating[] }> => {
        return fetch(`${settings.HOST}/Certificate/GetAllCertificationRatings`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    GetAllValidCertificates = async (order_by_text: string, ascending: Boolean, type: string): Promise<{ status: Boolean, data: Certificates[] }> => {
        return fetch(`${settings.HOST}/Certificate/GetAllValidCertificates/${order_by_text}/${ascending}/${type}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    GetMechanicsValidCertificatesByEmployeeId = async (employeeId: number): Promise<{ status: Boolean, data: Certificates[] }> => {
        return fetch(`${settings.HOST}/Certificate/GetMechanicsValidCertificatesByEmployeeId/${employeeId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    GetCertificateById = async (id: number): Promise<{ status: Boolean, data: CertificateData }> => {
        return fetch(`${settings.HOST}/Certificate/GetCertificateById/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    GetAllCertificateWaitingApproval = async (): Promise<{ status: Boolean, data: Certificates[] }> => {
        return fetch(`${settings.HOST}/Certificate/GetAllCertificateWaitingApproval`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    GetCertificateStatus = async (mechanic_user_id: number): Promise<{ status: Boolean, data: Certificates }> => {
        return fetch(`${settings.HOST}/Certificate/GetCertificateStatus/${mechanic_user_id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    GetCertificateHistoricalData = async (type: string, order_by_text: string, ascending: Boolean, aircraft: number[], rating: number[], onlyValid: boolean, employeeId: number, dateFrom: Date | null, dateTo: Date | null): Promise<{ status: Boolean, data: Certificates[], order_by_test: string, ascending: Boolean }> => {
        return fetch(`${settings.HOST}/Certificate/GetCertificateHistoricalData/${order_by_text}/${ascending}/${type}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(
                {
                    "mechanic_employee_id": employeeId,
                    "from_date": dateFrom,
                    "to_date": dateTo,
                    "aircraft_ids": aircraft,
                    "rating_ids": rating,
                    "onlyValid": onlyValid
                }
            )
        }).then(x => {
            return x.json()
        })
    }
    GetCertificateHistoricalDataToPdf = async (type: string, order_by_text: string, ascending: Boolean, aircraft: number[], rating: number[], onlyValid: boolean, employeeId: number, dateFrom: Date | null, dateTo: Date | null, isOnlySelectedFields: boolean): Promise<{ status: Boolean, data: Certificates[], order_by_test: string, ascending: Boolean }> => {
        return fetch(`${settings.HOST}/Certificate/GetCertificateHistoricalDataToPdf/${type}/${isOnlySelectedFields}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(
                {
                    "mechanic_employee_id": employeeId,
                    "from_date": dateFrom,
                    "to_date": dateTo,
                    "aircraft_ids": aircraft,
                    "rating_ids": rating,
                    "onlyValid": onlyValid
                }
            )
        }).then(x => {
            return x.json()
        })
    }
    ReturnDifferenceBetweenTwoCertificates = async (certificateId: number): Promise<{ status: Boolean, data: CertificateData, oldRatingIds:number[], newRatingIds:number[]}> => {
        return fetch(`${settings.HOST}/Certificate/ReturnDifferenceBetweenTwoCertificates/${certificateId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    CreateNewCertificateRating = async (ratingCategory: CertificateRating): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/CreateNewCertificateRating`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(ratingCategory)
        }).then(x => {
            return x.json()
        })
    }
    CreateNewAircraftCategory = async (aircraftCategory: CertificateAircraftCategory): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/CreateNewCertificateAircraftCategory`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(aircraftCategory)
        }).then(x => {
            return x.json()
        })
    }
    AddMessage = async (certificateId: number, message: string): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/AddMessage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                id: certificateId,
                message: message
            })
        }).then(x => {
            return x.json()
        })
    }
    CreateNewCertificateForEmployee = async (certificate: CertificateData): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/CreateNewCertificateForEmployee`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(certificate)
        }).then(x => {
            return x.json()
        })
    }
    SendEmailApprovalMessage = async (employeeEmail: string, body: string, subject: string, approvalSentByEmail: string): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/SendEmailApprovalMessage`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(
                {
                    "employee_email": employeeEmail,
                    "subject": subject,
                    "body": body,
                    "approvalSentByEmail": approvalSentByEmail,
                }
            )
        }).then(x => {
            return x.json()
        })
    }
    RemoveCertificateAircraftCategoryById = async (category: CertificateAircraftCategory): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/RemoveCertificateAircraftCategoryById/${category.id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(category)
        }).then(x => {
            return x.json()
        })
    }
    RemoveCertificateRatings = async (rating: CertificateRating): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/RemoveCertificateRatings/${rating.id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(rating)
        }).then(x => {
            return x.json()
        })
    }
    QualityAssuranceAccept = async (certificateId: number, approverId: number): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/QualityAssuranceAccept`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                id: certificateId,
                quality_assurance_employee_id: approverId,
            })
        }).then(x => {
            return x.json()
        })
    }
    QualityAssuranceReject = async (certificateId: number, approverId: number, declined_reason: string): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/QualityAssuranceReject`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                id: certificateId,
                quality_assurance_employee_id: approverId,
                declined_reason: declined_reason
            })
        }).then(x => {
            return x.json()
        })
    }
    GetAllFilteredCertificatesByIds = async (ids: number[]): Promise<{ status: Boolean, data: CertificateData[] }> => {
        return fetch(`${settings.HOST}/Certificate/GetAllFilteredCertificatesByIds`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify(ids)
        }).then(x => {
            return x.json()
        })
    }
    GetAllLicenses = async (): Promise<{ status: Boolean, data: License[] }> => {
        return fetch(`${settings.HOST}/Certificate/License`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    CreateLicense = async (ratingId:number, categoryId:number, licenseCode:string, licenseDescription: string, intervalMonths: number): Promise<{ status: Boolean, message: string, id:number }> => {
        return fetch(`${settings.HOST}/Certificate/License`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                rating_id: ratingId,
                category_id: categoryId,
                license_code: licenseCode,
                license_description: licenseDescription,
                interval_months: intervalMonths
            })
        }).then(x => {
            return x.json()
        })
    }
    DeleteLicense = async (licenseId: number): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/License/${licenseId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    UpdateLicense = async (license: License): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/License/${license.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                rating_id: license.rating_id,
                category_id: license.category_id,
                license_code: license.license_code,
                license_description: license.license_description
            })
        }).then(x => {
            return x.json()
        })
    }
    GetAllMxiLicenseCodes = async (): Promise<{ status: Boolean, data: MxiLicenseCode[] }> => {
        return fetch(`${settings.HOST}/Certificate/GetAllMxiLicenseCodes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }

    GetMaintenerSkills = async (): Promise<{ status: Boolean, data: Skill[] }> => {
        return fetch(`${settings.HOST}/Certificate/Skill`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    CreateSkill = async (skillCode: string, skillDescription: string): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/Skill`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                skill_description: skillDescription,
                skill_code: skillCode,
            })
        }).then(x => {
            return x.json()
        })
    }
    UpdateSkill = async (skill: Skill): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/Skill/${skill.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                skill_code: skill.skill_code,
                skill_description: skill.skill_description,
            })
        }).then(x => {
            return x.json()
        })
    }
    DeleteSkill = async (skillId: number): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/Skill/${skillId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            }
        }).then(x => {
            return x.json()
        })
    }
    GetMxiSkills = async (): Promise<{ status: Boolean, data: string[] }> => {
        return fetch(`${settings.HOST}/Certificate/Skill/Codes`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
        }).then(x => {
            return x.json()
        })
    }
    AddSkillsToLicense = async (licenseId: number, skillIds: number[]): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/License/${licenseId}/Skill`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                skill_ids: skillIds,
            })
        }).then(x => {
            return x.json()
        })
    }
    DeleteSkillsFromLicense = async (licenseId: number, skillIds: number[]): Promise<{ status: Boolean, message: string }> => {
        return fetch(`${settings.HOST}/Certificate/License/${licenseId}/Skill`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                skill_ids: skillIds,
            })
        }).then(x => {
            return x.json()
        })
    }
}
const CertificatesApi = new CertificateApi();
export default CertificatesApi;